import { Flex, Heading, Text } from '@pancakeswap/uikit'
import Container from 'components/Layout/Container'
import { FAQ_TYPE } from 'config'
import { useMemo } from 'react'
import { GetDataFAQ } from 'state/FAQ'
import { ContainerBanner } from '../styled'

const Banner = () => {
    // ================== VAR ==================
    // ================== STATE ==================
    const { activeTab } = GetDataFAQ()
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    const dataHeader = useMemo(() => {
        switch (activeTab) {
            case FAQ_TYPE.USER_MANUAL:
                return {
                    title: 'Hướng dẫn bắt đầu Gift cards.',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
            case FAQ_TYPE.ACCOUNT:
                return {
                    title: 'Tài khoản Gift cards.',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
            case FAQ_TYPE.ORDER_AND_PAYMENT:
                return {
                    title: 'Đặt hàng/thanh toán trên Gift cards.',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
            case FAQ_TYPE.CRYPTOCURRENCY_PAYMENT:
                return {
                    title: 'Sử dụng tiền điện tử thanh toán trên Gift cards dễ dàng hơn.',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
            case FAQ_TYPE.DIGITAL_GIFT_VOUCHERS:
                return {
                    title: 'Thẻ quà tặng & Phiếu quà tặng kỹ thuật số',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
            default:
                return {
                    title: 'Câu chuyện Gift cards.',
                    subTitle:
                        'Bạn có thể mua Voucher và thanh toán cho nhiều sản phẩm và các nhu cầu hàng ngày của bạn bằng Blockchain.',
                }
        }
    },[activeTab])
    // ================== RENDER ==================
    // ================== MAIN ==================

    return (
        <ContainerBanner>
            <Container width="100%">
                <Flex flexDirection="column" style={{ gap: '12px' }}>
                    <Heading scale="xxl" color="white">
                        {dataHeader?.title}
                    </Heading>
                    <Text color="white">
                       {dataHeader?.subTitle}
                    </Text>
                </Flex>
            </Container>
        </ContainerBanner>
    )
}
export default Banner
